"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M10.143 8.4c0 1.15.878 2 1.857 2 .98 0 1.857-.85 1.857-2s-.878-2-1.857-2c-.98 0-1.857.85-1.857 2Zm1.857 4c-2.175 0-3.857-1.838-3.857-4s1.682-4 3.857-4c2.175 0 3.857 1.838 3.857 4s-1.682 4-3.857 4Zm-1.278 10.012C8.462 19.484 4 13.105 4 8.4 4 3.756 7.577 0 12 0s8 3.756 8 8.4c0 4.705-4.462 11.084-6.722 14.012C12.513 23.404 12 24 12 24s-.513-.596-1.278-1.588ZM12 20.79a53.161 53.161 0 0 0 2.317-3.31c.964-1.5 1.902-3.15 2.593-4.77C17.612 11.065 18 9.59 18 8.4 18 4.767 15.227 2 12 2S6 4.767 6 8.4c0 1.19.388 2.666 1.09 4.31.69 1.62 1.629 3.271 2.593 4.771A53.161 53.161 0 0 0 12 20.791v-.001Z",
    clipRule: "evenodd"
  })]
});